// brain/cutover.js — EL SWITCH DEL CORTE (F6.5b, D-A capa 3 de D-I).
//
// false = fase sombra / pre-corte: el flujo online actual de Adaptive queda
//         INTACTO (la app sigue pidiendo cada respuesta a /study) y el
//         despachador NO existe en runtime (candado G.9: en sombra no se
//         sube nada, por construcción).
// true  = el corte del cable: Adaptive corre 100% local en la app (con o
//         sin red) — la sustitución por fetcher de AdaptiveStudy y el
//         mini-despachador se encienden JUNTOS con esta constante.
//
// Se activa SOLO tras la ratificación del smoke 1 (checkpoint 2 del
// sprint), en su propio commit de una línea. La web JAMÁS entra aquí:
// adaptiveRunsLocally() es falso por construcción fuera del build de app.
import { IS_APP_BUILD } from '../buildTarget';

export const ADAPTIVE_LOCAL_CUTOVER = true;

// F6.6a (D-P): flag HERMANO, no compartido — permite recular Flashcards sin
// tocar Adaptive (y viceversa).
export const FLASHCARDS_LOCAL_CUTOVER = true;

// F6.6b Tanda 2b (D-P): el TERCER hermano. Enciende JUNTO con la sustitución
// por fetcher de ExamSimulator, el carril de pausas del cartero y el
// barrendero de boot de D-N. Recular el examen es apagar ESTA línea: adaptive
// y flashcards no se enteran.
export const EXAM_LOCAL_CUTOVER = true;

// F6.8 Tanda 3 — EL CUARTO HERMANO, y el primero que NO es un modo de estudio.
// Analytics no corre sesiones ni escribe un solo renglón del diario: lo que este
// corte enciende es que la PANTALLA de analíticas pueda resolverse desde la
// bodega — el atajo por dictamen del vigía y la caída por forma-de-red, ambos
// contra los ensambladores de `warehouse/screenSources`.
//
// SEMÁNTICA (β, firmada): NO es siempre-local. Con señal, Analytics pide al
// servidor EXACTAMENTE como hoy y la bodega ni se toca; apagar esta línea
// devuelve la pantalla a su comportamiento de hoy sin tocar a los otros tres.
//
// Y por eso NO entra en anyModeRunsLocally(): ese OR gatea al cartero, que sube
// renglones de los MODOS. Analytics solo LEE — no le da nada que subir.
export const ANALYTICS_LOCAL_CUTOVER = true;

export function adaptiveRunsLocally() {
  return IS_APP_BUILD && ADAPTIVE_LOCAL_CUTOVER;
}

export function flashcardsRunLocally() {
  return IS_APP_BUILD && FLASHCARDS_LOCAL_CUTOVER;
}

export function examRunsLocally() {
  return IS_APP_BUILD && EXAM_LOCAL_CUTOVER;
}

export function analyticsRunsLocally() {
  return IS_APP_BUILD && ANALYTICS_LOCAL_CUTOVER;
}

// ¿ALGÚN modo corre local? El gate del despachador y el disparador de boot
// consumen ESTO (no un flag de modo): el cartero sube renglones de todos los
// modos y debe existir mientras cualquiera escriba el diario.
//
// ANALYTICS_LOCAL_CUTOVER queda FUERA a propósito: no es un modo, no escribe
// diario y meterlo aquí levantaría al cartero por una pantalla de solo lectura.
export function anyModeRunsLocally() {
  return adaptiveRunsLocally() || flashcardsRunLocally() || examRunsLocally();
}
